import { Ulid, VatClassGet } from "@kase/my-marathon-communication";
import { computed, signal } from "@preact/signals";
import { dateFromApi } from "~/utils";
import { ApiSliceParams } from "../interfaces";
import { createListController } from "../utils";
import { VatClass } from "./interfaces";

export const makeVatClass = ({ connection, company }: ApiSliceParams) => {
    const {
        items: periods,
        listen: listenPeriods,
        whenLoaded: whenPeriodsLoaded,
    } = createListController({
        connection,
        list: (con) => con.company.period.items({ company: company.value }),
        sort: (a, b) => b.end - a.end,
        name: "period",
    });
    const {
        items: vatClasses,
        listen: listenVatClasses,
        loading: loadingVatClasses,
    } = createListController<VatClassGet, VatClass, number>({
        connection,
        list: (con, year) =>
            con.vatClass.items({ company: company.value, year }),
        getKey: (year) => year.toString(),
        name: "vatClass",
    });
    const bookKeepYear = signal(0);
    const finished = signal(false);
    const loading = computed(() => {
        const f = finished.value;
        const y = bookKeepYear.value;

        if (f) {
            return false;
        }

        if (!y) {
            return true;
        }

        return loadingVatClasses(y).value;
    });

    const listen = async () => {
        listenPeriods();

        await whenPeriodsLoaded();

        const today = new Date();
        const period =
            periods
                .peek()
                .find(
                    (p) =>
                        dateFromApi(p.start) <= today &&
                        dateFromApi(p.end) >= today,
                ) ?? periods.peek()[0];

        finished.value = true;

        if (!period) {
            return;
        }

        bookKeepYear.value = period.bookkeep_year;
        listenVatClasses(period.bookkeep_year);
    };

    const get = (id: string | null | undefined | Readonly<Ulid>) => {
        if (!id) {
            return null;
        }

        const finalId = typeof id === "string" ? id : id.toString();

        return vatClasses.peek().find((e) => e.id === finalId) ?? null;
    };

    return {
        vatClasses,
        loading,
        listen,
        get,
    };
};
